import { array, struct, union } from 'io-ts/Decoder';

import { Id as Level } from '../../../../ai/floor-level/Id';
import { Id as TakeOffId } from '../../../../whole-house/take-off/Id';

export const Request = union(
	struct({
		level: Level,
		takeOffIds: array(TakeOffId),
	}),
	struct({
		takeOffIds: array(TakeOffId),
	})
);
